<template>
<div>
<v-layout fluid style="width: 100%;" class="pa-0 d-flex flex-row" lights-out>
	<v-row class="ma-0">
    <v-col cols="12" sm="12" md="3"  :style="{'background-color': color}">
        <v-row>
			<v-col cols="auto">
				<slot name="breadcrumbs" :item="true"></slot>
			</v-col>
			<v-spacer/>
			<!-- export -->
			<v-col cols="auto">
				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn dark color="printingColor" class="px-2" v-on="on">
							<span class="d-flex align-center">
								<v-icon color="white">mdi-export-variant</v-icon>
								<span style="font-size: 14px">
									{{$t('AccountsTreePage.export')}}
								</span>
							</span>
						</v-btn>
					</template>

					<bee-list>
						<!-- excel -->
						<bee-list-item
							context="tree"
							:item="exportItems[0]"
							dense
							@click="exportAs('excel')"
						></bee-list-item>

						<!-- pdf -->
						<bee-list-item
							context="tree"
							:item="exportItems[1]"
							dense
							@click="exportAs('pdf')"
						></bee-list-item>
					</bee-list>
				</v-menu>
			</v-col>
		</v-row>
		<v-row fill-height>
			<v-main style="width: 100%" class="px-3 pt-0 pb-3" color="greyLighten5">
				<!-- <v-treeview
					v-if="renderComponent"
					@update:active="showProfile($event)"
					:filter-hint="$t('AccountsTreePage.account-num-or-name')"
					:lables-values="['accounting_no', 'name']"
					:items="accounts_tree"
					show-context-menu
					:contextmenu-items="[
						{ title: $t('buttons.add-child'), event: 'add-child', disabled: item => item.type === 2 },
						{ title: $t('buttons.account-statement'), event: 'account-statement' },
						{ title: $t('buttons.edit'), event: 'edit' },
						{ title: $t('buttons.delete'), event: 'delete' },
					]"
					@context-menu-add-child="(item) => {
						node = {...item};
						selected = true;
						$route.params.parentId !== item.id
							? $router.push({ name: 'add-account', params: { parentId: item.id } })
							: null
					}"
					@context-menu-account-statement="item => $router.push({ name: 'statement', params: { id: item.id } })"
					@context-menu-edit="showProfile($event, true)"
					@context-menu-delete="showProfile($event, false, true)"
				>
					<template v-slot:actions="{}">
                        <bee-btn
						@click="createAccount()"
						:disabled="file_is_locked"
						color="addingColor"
						:content="$t('AccountsTreePage.add')"
						icon="fa-user-plus"
						context="account"
						:action-name="actions.CREATE"
						v-if="$route.name != 'edit-account'"
						></bee-btn>
                    </template>
				</v-treeview> -->
				<v-row>
					<v-col cols="8" class="px-1">
						<v-autocomplete
							v-model="accountId"
							class="text-subtitle-2"
							:items="flatAccounts"
							outlined
							hide-no-data
							dense
							clearable
							:label="$t('AccountsTreePage.account-num-or-name')"
							hide-details
							item-value="id"
							:item-text="item => item.accounting_no + '-' + item.name"
							@change="accountsTreeFilterActivate(accountId)"
						>
						</v-autocomplete>
					</v-col>
					<v-col cols="4" class="d-flex justify-end align-center">
						<bee-btn
							v-if="$route.name != 'edit-account'"
							:disabled="file_is_locked || ( $route.params.id && configs?.accounts.find( v => v.id === +$route.params.id)?.type !== type.main)"
							color="addingColor"
							:content="$t('AccountsTreePage.add')"
							icon="fa-user-plus"
							context="account"
							:action-name="actions.CREATE"
							@click="createAccount()"
						></bee-btn>
					</v-col>
				</v-row>
				<div class="pt-5" @contextmenu.prevent>
					<v-treeview
						id="tree-view"
						:open.sync="openedNodes"
						:active.sync="activeAccounts"
						:style="`overflowY:auto;height:${$vuetify.breakpoint.height - 270 + 'px'}`"
						:items="accounts_tree"
						show-context-menu
						activatable
						item-text=""
						transition
						dense
						selected-color="primary"
						return-object
						hoverable
						@update:active="showProfile($event)"
					>
						<!-- @context-menu-add-child="(item) => {
							node = {...item};
							selected = true;
							$route.params.parentId !== item.id
								? $router.push({ name: 'add-account', params: { parentId: item.id } })
								: null
						}"
						@context-menu-account-statement="item => $router.push({ name: 'statement', params: { id: item.id } })"
						@context-menu-edit="showProfile($event, true)"
						@context-menu-delete="showProfile($event, false, true)"
						-->
						<template v-slot:prepend="{item}">
							<v-icon 
								v-if="item.children ? item.children.length > 0 : false"
								class="me-1"
								small 
								color="#d9bd5d"
								@click.stop="openNodes(item)"
							>
								{{openedNodes.find(v => v === item) ? 'fa-minus' : 'fa-plus'}}
							</v-icon>
							<div v-else class="px-1"></div>
						</template>
						<template v-slot:label="{item}">
							<div
								@contextmenu.prevent="initContextMenu($event, item)"
							>
								<p :ref="'account-'+ item.id" class="ma-0 text-subtitle-2" :class="{'deletingColor--text':item.type === 1}">
									{{
										item.accounting_no + '-' + item.name
									}}
								</p>
							</div>
						</template>
					</v-treeview>
					<!-- context menu -->
					<v-menu
						v-model="contextMenuData.show"
						:position-x="contextMenuData.x"
						:position-y="contextMenuData.y"
						absolute
						offset-y
					>
						<v-list dense>
							<v-list-item
								v-for="(item, index) in contextMenuItems"
								:key="index"
								:disabled="typeof item.disabled === 'function' ? item.disabled(contextMenuData.node) : Boolean(item.disabled)"
								@click="item.action(contextMenuData.node)"
							>
								<v-list-item-title class="text-capitalize">{{ item.title }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</v-main>
		</v-row>
    </v-col>

    <v-col cols="auto" sm="12" md="9" :style="`maxHeight:${$vuetify.breakpoint.height - 130 + 'px'};overflowY:auto`">
		<v-scroll-y-transition mode="out-in">
			<v-card flat style="height: 100%" v-if="!selected" class="d-flex flex-column justify-content-center justify-center py-0">
			<v-card-text>
			<v-img
					left
					class="shrink"
					contain
					:src="require('../../../assets/selectUser.png')"
					transition="scale-transition"
					height="200"
				/>
			</v-card-text>
			<v-card-title class="align-center justify-center">
				<span style="align-self: center;" class="blue-grey--text text--lighten-1 font-weight-light">
					{{$t('AccountsTreePage.please-select-account')}}
				</span>
			</v-card-title>
			</v-card>
			
			<router-view v-else @reload-accounts-tree="accounts_tree.forEach(v => {
				convertTreeToArray(v);
			})" ></router-view>
		</v-scroll-y-transition>
	</v-col>
	</v-row>
</v-layout>
<v-bottom-navigation
	app
    class="px-3"
    horizontal
    background-color="greyLighten3">
    <v-row align="center" justify="center">
        <bee-outlined-header-info :head="$t('AccountsTreePage.number-of-main-accounts')" empty-state="_" :content="configs? configs.num_of_primary_accounts : null">
        </bee-outlined-header-info>
        <bee-outlined-header-info :head="$t('AccountsTreePage.number-of-sub-accounts')" empty-state="_" :content="configs? configs.num_of_secondary_accounts : null">
        </bee-outlined-header-info>
    </v-row>
</v-bottom-navigation>
</div>
</template>
<script>
import { mapState } from "vuex";
import  store  from "../../../store/index.js";
// import EventBus from '../../../event-bus';
import actions from "../../../permissions/actions-names.js"
import ls from '../../../settings/localStorageExtension';
import { type } from '@/helpers/enums'
export default {
data: () => ({
	actions,
	renderComponent:true,
    selected: false,
	items:[],
	node: {id: null},
	activeAccounts: [],
	openedNodes: [],
	lastOpenedNodes: [],
	type,
	contextMenuData: {
		node: {},
		show: null,
		x: null,
		y: null,
	},
	flatAccounts: [],
	accountId: null

  }),
  watch: {
	$route(to) {
		this.selected = !(this.$route.name == "accounts-tree")
		if (to.params.id) {
			this.accountsTreeFilterActivate(to.params.id)
		}
	},
  },
computed: {
	...mapState("configs", ["configs"]),
	...mapState( "accounts" , ["accounts_tree"] ),
	exportItems() {
		return [
			{
				text: this.$t('AccountsTreePage.export-as-excel'),
				icon: 'mdi-microsoft-excel',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
			{
				text: this.$t('AccountsTreePage.print-accounts-tree'),
				icon: 'mdi-printer',
				context: 'tree',
				action_name: actions.EXPORT_AS_PDF
			},
		]
	},
	color() {
      return this.$vuetify.theme.themes.light.greyLighten5;
	},
	show_action_bar(){
		return (this.$route.name == "accounts-tree") || (this.$route.name == "account")
	},
	file_is_locked(){
        return this.configs?.financial_file?.is_locked 
	},
	contextMenuItems() {
		return [
			{ 
				title: this.$t('buttons.add-child'), 
				event: 'add-child', 
				disabled: item => item.type === 2, 
				action: item => {
					this.$route.params.parentId !== item.id
					? this.$router.push({ name: 'add-account', params: { parentId: item.id } })
					: null
				} 
			},
			{ 
				title: this.$t('buttons.account-statement'), 
				event: 'account-statement' ,
				action: item => {
					this.$router.push({ name: 'statement', params: { id: item.id }})
				}
			},
			{ 
				title: this.$t('buttons.edit'), 
				event: 'edit',
				action: item => {
					this.showProfile(item, true)
				} 
			},
			{ 
				title: this.$t('buttons.delete'),
				event: 'delete',
				action: item => {
					this.showProfile(item, false, true)
				} 
			},
		]
	}
},
methods: {
	openNodes(item) {
		const index =this.openedNodes.findIndex(t => t===item)
		if(index !==-1) {
			this.openedNodes.splice(index, 1);
		} else {
			this.openedNodes.push(item)
		}
	},
    showProfile(items, isEdit = false, isDelete = false) {
		this.selected = true
		const item = Array.isArray(items) ? items[0] : items
		if(item?.id !== this.accountId) {
			this.accountId = null
		}
		if(item)
		{
			const route = {
				name: !isEdit ? 'account' : 'edit-account',
				params: { id: item.id },
			}
			if (isDelete) {
				route.query = { isDelete: true }
			}
			this.$router.push(route).catch(() => {})
			this.node = {...item}
			store.dispatch("statements/fetchAccountStatementSummary", { accountId: item.id })
		}
		else{
			this.$router.push({ name: "accounts-tree"}).catch(()=>{})
			this.node = null
		}	
	},
	createAccount() {
		this.node?.id  && this.selected
			? this.$router.push({ name: "add-account", params: { parentId: this.node.id } }).catch(()=>{}) 
			: this.$router.push({ name: "create-account" }).catch(()=>{})
		},
	// forceRerender() {
    //     // Remove my-component from the DOM
    //     this.renderComponent = false;

    //     setTimeout(() => {
    //       // Add the component back in
    //       this.renderComponent = true;
    //     }, 2000);
	// },
	initContextMenu(e, item) {
		this.contextMenuData.x = e.clientX;
		this.contextMenuData.y = e.clientY;
		this.contextMenuData.node = item;
		this.$nextTick(() => {
			this.contextMenuData.show = true
		})

	},
	accountsTreeFilterActivate(accountId) {
		if(accountId) {
			this.activeAccounts = [];
			// this.openedNodes = [];
			const account = this.flatAccounts.find(v => v.id === accountId);
			this.activeAccounts.push(account);
			if(account.parent_accounting_no) {
				this.accountsTreeFilterNodesOpen(account.parent_accounting_no);
			}
			this.$nextTick(() => {
				setTimeout(() =>{
					const el = this.$refs['account-' + accountId];
					if (el) {
						el.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				}, 100)
			})

			
		}
	},
	accountsTreeFilterNodesOpen(accountNo) {
		const account = this.flatAccounts.find(v => v.accounting_no == accountNo);
		this.openedNodes.push(account);
		if(account.parent_accounting_no) {
			this.accountsTreeFilterNodesOpen(account.parent_accounting_no);
		}
	},
	convertTreeToArray(item) {
		this.flatAccounts.push(item);
		if(item.children)
		{
			item.children.forEach(v => {
				this.convertTreeToArray(v)
			})
		}

	},
	exportAs(type) {
        this.$store.dispatch('reports/AccountsTreeReport', {
            type,
            financialFileId: this.configs.financial_file.id,
			userId: ls.getLocalUser().id,
        })
    }
},
mounted(){
	// EventBus.$on('reload-accounts-tree', ()=>{ this.forceRerender()});

	let promises = [store.dispatch("accounts/fetchTree")]
	let custom_statements = JSON.parse(JSON.stringify(store.state.customStatements.custom_statements))
	if(Object.keys(custom_statements).length == 0)
		promises.push(store.dispatch("customStatements/fetchAll"))

	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
	if(Object.keys(configs).length == 0)
		promises.push(store.dispatch('configs/fetchAll'))

	Promise.all(promises).then(() => {
		this.accounts_tree.forEach(v => {
			this.convertTreeToArray(v);
		})
		if(this.$route.name === 'accounts-tree') {
			this.selected = false;
		} else {
			this.selected = true
			this.accountsTreeFilterActivate(+this.$route.params.id)
		}
	})
},
// async beforeRouteEnter(to, from, next) {

// 	let promises = [store.dispatch("accounts/fetchTree")]
		

// 	let custom_statements = JSON.parse(JSON.stringify(store.state.customStatements.custom_statements))
// 	if(Object.keys(custom_statements).length == 0)
// 		promises.push(store.dispatch("customStatements/fetchAll"))

// 	let configs = JSON.parse(JSON.stringify(store.state.configs.configs))
// 	if(Object.keys(configs).length == 0)
// 		promises.push(store.dispatch('configs/fetchAll'))

// 	await Promise.all(promises)

//     next(vm => {
// 		to.name == "accounts-tree" ? vm.selected = false : vm.selected = true
//     })
// },
meta: {
		title: 'accounts-tree',
		meta: [
			{property: 'og:title', content: 'accounts-tree / mirta'},
		],
	},
};
</script>
<style lang="scss" scoped>
#tree-view{
	.v-treeview-node__toggle{
		display: none;
	}
	cursor: pointer;
}
.v-btn--outlined{
    border: solid #608391 !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
	margin-right: 60px !important;
	align-items: center !important;
    display: flex !important;
    justify-content: center !important;
}
.v-bottom-navigation {
  overflow-y: unset;
}
@media screen and (max-width: 480px) {
.v-bottom-navigation {
  overflow-y: scroll !important;
}
}
</style>
<style>
.fixed {
  position: static;
}
</style>